<template>
    <div>
      <Breadtabsheader/>
        <div class="h-content">

            <!--查询表单-->
            <div class="h-piece">
                <div class="">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
						<div class="h-formBox w-formBox">
							<el-form-item label="选择年">
								<el-date-picker
										style="width: 100%;"
										:clearable="false"
										prop ="qijianLike"
										v-model="q.qijianLike"
										type="year"
										value-format="yyyy"
										placeholder="--年份--">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="合同分类" prop="contractBaseId">
								<brselect category="fl_contract_type" :v="q.contractBaseId" v-model="q.contractBaseId" :clearable="true"/>
							</el-form-item>
							<el-form-item>
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
							</el-form-item>
						</div>
                    </el-form>
                </div>
            </div>


            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table
                          ref="ddtable"
                          :data="tableData"
                          stripe
                          style="width: 100%"
                          :border="true"
						  max-height="490"
                >
                    <el-table-column
                            type="index"
							fixed
                            label="#"
                            width="40">
                    </el-table-column>
                    <el-table-column
                            prop="qijian"
                            :show-overflow-tooltip="true"
                            label="期间"
                            min-width="100"
                    >
                    </el-table-column>
					<el-table-column
							prop="contractBaseId"
							:show-overflow-tooltip="true"
							label="合同分类"
							min-width="100"
					>
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.contractBaseId|dictname('fl_contract_type')}}
							</div>
						</template>
					</el-table-column>
                    <el-table-column label="合计" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="zqycount"
								width="120"
                                :show-overflow-tooltip="true"
                                label="签约客户数量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.zqycount}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="zyrcount"
								width="120"
                                :show-overflow-tooltip="true"
                                label="引入客户数量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.zyrcount}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="ztccount"
								width="120"
                                :show-overflow-tooltip="true"
                                label="退出客户数量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.ztccount}}
								</div>
							</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="一级经销商" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="cqycount"
								width="120"
                                :show-overflow-tooltip="true"
                                label="签约客户数量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.cqycount}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="cyrcount"
								width="120"
                                :show-overflow-tooltip="true"
                                label="引入客户数量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.cyrcount}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="ctccount"
								width="120"
                                :show-overflow-tooltip="true"
                                label="退出客户数量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.ctccount}}
								</div>
							</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="专营商" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="uqycount"
								width="120"
                                :show-overflow-tooltip="true"
                                label="签约客户数量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.uqycount}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="uyrcount"
								width="120"
                                :show-overflow-tooltip="true"
                                label="引入客户数量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.uyrcount}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="utccount"
								width="120"
                                :show-overflow-tooltip="true"
                                label="退出客户数量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.utccount}}
								</div>
							</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="地市直营商" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="xqycount"
								width="120"
                                :show-overflow-tooltip="true"
                                label="签约客户数量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.xqycount}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="xyrcount"
								width="120"
                                :show-overflow-tooltip="true"
                                label="引入客户数量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.xyrcount}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="xtccount"
								width="120"
                                :show-overflow-tooltip="true"
                                label="退出客户数量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.xtccount}}
								</div>
							</template>
                        </el-table-column>
                    </el-table-column>
					<el-table-column label="分销商3.0" :show-overflow-tooltip="true">
						<el-table-column
								prop="sqycount"
								width="120"
								:show-overflow-tooltip="true"
								label="签约客户数量"
						>
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.sqycount}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="syrcount"
								width="120"
								:show-overflow-tooltip="true"
								label="引入客户数量"
						>
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.syrcount}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="stccount"
								width="120"
								:show-overflow-tooltip="true"
								label="退出客户数量"
						>
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.stccount}}
								</div>
							</template>
						</el-table-column>
					</el-table-column>
				</el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel"  v-auth="'khsltj_daochu'">批量导出
                        </el-button>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'

    export default {
        components: {},
        data() {
            return {
                //查询属性
                page:{
                    pageSize:20,
                    pageNo:1
                },
                q: {
                    qijianLike:new Date().getFullYear().toString(),
					contractBaseId:1,
                    pageSize: 12,
                    pageNo: 1,
                    total: 0,
                },
                //table列表
                tableData: [],
            }
        },
        created() {
			this.q.contractBaseId = 1;
			this.q.qijianLike = new Date().getFullYear().toString();
            this.query();
        },
        methods: {
            //重置
            qingkong(){
				this.q={
					qijianLike : new Date().getFullYear().toString(),
					contractBaseId : 1,
					pageSize: 12,
					pageNo: 1,
					total: 0,
				}
				this.query();
            },
            query() {
                ss.fanli.pagecount(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                });

            },
            handleFilter() {
                this.query();
            },
            //批量导出
            exportExcel() {
				updownfile.down("/api/swyl/v1/fanli/hetong/flContractAgent/downfanliCustomerCountEntityExcel", this.q, "post");
            },
        }
    }
</script>
<style>
    .el-table thead.is-group th{
        background-color: #57aefe;
    }
</style>
